import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createBlock as _createBlock, normalizeClass as _normalizeClass, withCtx as _withCtx } from "vue"
import _imports_0 from '../../../../assets/aw-footer-logo.jpg'


const _hoisted_1 = { class: "report-template" }
const _hoisted_2 = {
  key: 0,
  class: "section"
}
const _hoisted_3 = { class: "section-content" }
const _hoisted_4 = {
  key: 1,
  class: "report-chart"
}
const _hoisted_5 = {
  key: 2,
  class: "section"
}
const _hoisted_6 = { class: "section-content" }
const _hoisted_7 = { class: "text--green bold-700" }
const _hoisted_8 = { class: "text--red bold-700" }
const _hoisted_9 = {
  key: 3,
  class: "report-chart"
}
const _hoisted_10 = { class: "footer" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Watermark = _resolveComponent("Watermark")!
  const _component_AIRRChart = _resolveComponent("AIRRChart")!
  const _component_AssetImpactChart = _resolveComponent("AssetImpactChart")!
  const _component_v_img = _resolveComponent("v-img")!
  const _component_v_card = _resolveComponent("v-card")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_Watermark, { isSampleReport: _ctx.isSampleReport }, null, 8, ["isSampleReport"]),
    _createVNode(_component_v_card, {
      class: "report-page-card",
      outlined: "",
      flat: ""
    }, {
      default: _withCtx(() => [
        (_ctx.filters.Irr)
          ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
              _cache[0] || (_cache[0] = _createElementVNode("div", { class: "section-title" }, [
                _createElementVNode("div", { class: "section-badge" }),
                _createTextVNode(" Actual IRR Distribution ")
              ], -1)),
              _createElementVNode("div", _hoisted_3, " The Internal Rate of Return is calculated using the contribution history of savers. It takes the time value of money into account and generates annualised returns. The IRR distribution below shows the number of pots in different ranges of IRRs. The average IRRs for data provided is " + _toDisplayString((_ctx.filterRanges && (_ctx.filterRanges.irrRange.avg * 100).toFixed(2)) || '') + "%. ", 1)
            ]))
          : _createCommentVNode("", true),
        (!_ctx.fetchingChartData && _ctx.filters.Irr)
          ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
              (_ctx.airrData)
                ? (_openBlock(), _createBlock(_component_AIRRChart, {
                    key: 0,
                    "data-testid": "AIRRChart",
                    chartData: _ctx.airrData,
                    barColor: _ctx.barColor,
                    provider: _ctx.filters.provider,
                    priceTrack: _ctx.filters.priceTrackObject,
                    isSampleReport: _ctx.isSampleReport,
                    reportfilterRanges: _ctx.reportfilterRanges
                  }, null, 8, ["chartData", "barColor", "provider", "priceTrack", "isSampleReport", "reportfilterRanges"]))
                : _createCommentVNode("", true)
            ]))
          : _createCommentVNode("", true),
        (_ctx.filters.iAsset && _ctx.filterRanges)
          ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
              _cache[2] || (_cache[2] = _createElementVNode("div", { class: "section-title" }, [
                _createElementVNode("div", { class: "section-badge" }),
                _createTextVNode(" Impact on Asset Value ")
              ], -1)),
              _createElementVNode("div", _hoisted_6, [
                _cache[1] || (_cache[1] = _createTextVNode(" The AgeWage score is calculated by comparing the Net Asset Value of a member against the value they would have generated in the Benchmark index with the same contribution history. The following graph compares the Net Asset Value of all the members against their benchmark value. A net of ", -1)),
                _createElementVNode("span", {
                  class: _normalizeClass(_ctx.iavText.diffStatus === 'generated' ? 'text--green bold-700' : 'text--red bold-700')
                }, _toDisplayString(_ctx.formatNumber(_ctx.iavText.netDiffVal, '$0.00a')), 3),
                _createTextVNode(" " + _toDisplayString(_ctx.iavText.diffStatus === 'generated' ? 'excess' : '') + " value was " + _toDisplayString(_ctx.iavText.diffStatus) + " compared to the benchmark as a result of " + _toDisplayString(_ctx.iavText.performanceStatus) + " performance of the assets. As shown in the figure below, ", 1),
                _createElementVNode("span", _hoisted_7, _toDisplayString(_ctx.formatNumber(_ctx.iavText.scorePart2.value, '$0.00a')), 1),
                _createTextVNode(" of value was generated as a result of over performance for the " + _toDisplayString(_ctx.numberWithCommas(_ctx.iavText.scorePart2.count, false)) + " members with scores greater than 50, while ", 1),
                _createElementVNode("span", _hoisted_8, _toDisplayString(_ctx.formatNumber(_ctx.iavText.scorePart1.value, '$0.00a')), 1),
                _createTextVNode(" of value was lost as a result of under performance for the " + _toDisplayString(_ctx.numberWithCommas(_ctx.iavText.scorePart1.count, false)) + " members with scores less than 50 ", 1)
              ])
            ]))
          : _createCommentVNode("", true),
        (!_ctx.fetchingChartData && _ctx.filters.iAsset && _ctx.filterRanges)
          ? (_openBlock(), _createElementBlock("div", _hoisted_9, [
              (_ctx.iavData)
                ? (_openBlock(), _createBlock(_component_AssetImpactChart, {
                    key: 0,
                    chartData: _ctx.iavData,
                    iavData: _ctx.iavChartData,
                    plotterColor: _ctx.plotterColor,
                    provider: _ctx.filters.provider,
                    priceTrack: _ctx.filters.priceTrackObject,
                    isSampleReport: _ctx.isSampleReport,
                    reportfilterRanges: _ctx.reportfilterRanges
                  }, null, 8, ["chartData", "iavData", "plotterColor", "provider", "priceTrack", "isSampleReport", "reportfilterRanges"]))
                : _createCommentVNode("", true)
            ]))
          : _createCommentVNode("", true),
        _createElementVNode("div", _hoisted_10, [
          _cache[3] || (_cache[3] = _createElementVNode("div", null, null, -1)),
          _createVNode(_component_v_img, {
            class: "footer-img",
            src: _imports_0
          })
        ])
      ]),
      _: 1
    })
  ]))
}